import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { AlgoHedgeConfigInfoImpl } from "../model/impl/AlgoHedgeConfigInfoImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class AlgoHedgeConfigInfoImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: AlgoHedgeConfigInfoImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.algoHedgeId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(1),
        false,
        encodable.algoHedgeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(2),
        false,
        encodable.traderGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupNm != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(3),
        false,
        encodable.traderGroupNm,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.enabledFg != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(4),
        false,
        encodable.enabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.orderType != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(5),
        false,
        encodable.orderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.algoProfile != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(6),
        false,
        encodable.algoProfile,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.startTimeOffset != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(7),
        false,
        encodable.startTimeOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.endTimeOffset != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(8),
        false,
        encodable.endTimeOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyParams != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        true,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(9),
        false,
        encodable.strategyParams,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.Long"],
    [3, "java.lang.String"],
    [4, "java.lang.Boolean"],
    [5, "java.lang.String"],
    [6, "java.lang.String"],
    [7, "java.lang.Long"],
    [8, "java.lang.Long"],
    [9, "com.bcdfx.model.StrategyParameter"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: AlgoHedgeConfigInfoImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.algoHedgeId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.traderGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.traderGroupNm = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.enabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.orderType = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.algoProfile = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.startTimeOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.endTimeOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameter> = this.baseEncoder.readObject(
            false,
            true,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.strategyParams = <Array<CubiqTS.StrategyParameter>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,AlgoHedgeConfigInfoImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return AlgoHedgeConfigInfoImplEncoder.fidTypeMap.has(fid);
  }
}
